import React, { useEffect, useState } from 'react';
import { DropdownContent, DropdownToggle } from '@prisjakt/ui/dropdown';
import { useProductContext } from '../product-context';
import type { ProductRelation } from 'src/types';
import {
  ModalFooterContent,
  OutlinedModalButton,
  RelationItem,
  StyledRelationsDropDown,
} from './styles';
import { FontColor, H4Text, TitleSmallText } from '@prisjakt/ui/text/variants';
import { Link } from 'react-router-dom';
import { Modal, ModalFooter } from '@prisjakt/ui/modal';
import { IconDropdownDown } from '@prisjakt/ui/icon/dropdown-down';
import { TonalButton } from '@prisjakt/ui/button/variants';

type RelationsDropdownProps = {
  relationType: string;
  title: string;
};

export const RelationsDropdown = ({
  relationType,
  title,
}: RelationsDropdownProps) => {
  const [relationItems, setRelationItems] = useState<ProductRelation[]>();
  const [selected, setSelected] = useState<ProductRelation>();
  const [isOpen, setIsOpen] = useState(false);

  const { product } = useProductContext();

  useEffect(() => {
    if (!product?.relations || product.relations?.length <= 0) {
      return;
    }
    getRelationList();
  }, []);

  const getRelationList = () => {
    const relations = product.relations
      ?.filter(relation => relation.type === relationType)[0]
      .relations.filter(item => item.sortPriority !== 0)
      .sort((a, b) => a.sortPriority - b.sortPriority);

    if (!relations) {
      return;
    }

    setSelected(relations.filter(item => item.selected)[0]);
    setRelationItems(relations);
  };

  if (!selected || !relationItems) {
    return null;
  }

  const renderRelationList = () => {
    const items = relationItems?.map(item => (
      <RelationItem key={item.name}>
        <TitleSmallText>
          <Link to={`${product.category?.pathName}?q_name=${item.name}`}>
            {item.name}
          </Link>
        </TitleSmallText>
      </RelationItem>
    ));

    return (
      <>
        <RelationItem>
          <TitleSmallText>{selected.name}</TitleSmallText>
        </RelationItem>
        {items}
      </>
    );
  };

  const renderContent = () => (
    <>
      <RelationItem>
        <H4Text>{title}</H4Text>
      </RelationItem>
      {renderRelationList()}
    </>
  );

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        title={title}
      >
        {renderRelationList()}
        <ModalFooter>
          <ModalFooterContent>
            <TonalButton onClick={() => setIsOpen(false)}>Close</TonalButton>
          </ModalFooterContent>
        </ModalFooter>
      </Modal>

      <OutlinedModalButton onClick={() => setIsOpen(true)}>
        {selected.name} <IconDropdownDown />
      </OutlinedModalButton>

      <StyledRelationsDropDown>
        <DropdownToggle showActiveIcon>
          <TitleSmallText color={FontColor.PRIMARY}>
            {selected.name}
          </TitleSmallText>
        </DropdownToggle>
        <DropdownContent height={280} width={320}>
          {renderContent()}
        </DropdownContent>
      </StyledRelationsDropDown>
    </>
  );
};
